export const RCV_INVITATION_BODY = `Something New has invited you to a RingCentral Video meeting.

    Please join using this link:
        https://v.ringcentral.com/join/036308267?pw=af8e831dc8755c9a62247eba3e3745d0

    Meeting ID: 036308267

    Password: S9CYN1DxZC

    One tap to join audio only from a smartphone:
        +15148191648,,036308267#,,7929613992# Canada (Montreal, QC)
        +14318001649,,036308267#,,7929613992# Canada (Winnipeg, MB)
        +17782008149,,036308267#,,7929613992# Canada (Vancouver, BC)
        +15873153501,,036308267#,,7929613992# Canada (Calgary, AB)
        +13065001584,,036308267#,,7929613992# Canada (Saskatoon, SK)
        +14378000918,,036308267#,,7929613992# Canada (Toronto, ON)

    Or dial:
        +15148191648 Canada (Montreal, QC)
        +14318001649 Canada (Winnipeg, MB)
        +17782008149 Canada (Vancouver, BC)
        +15873153501 Canada (Calgary, AB)
        +13065001584 Canada (Saskatoon, SK)
        +14378000918 Canada (Toronto, ON)

        Access Code / Meeting ID: 036308267

    Dial-in password: 7929613992

    International numbers available: https://v.ringcentral.com/teleconference`;

export const RCV_INVITATION_START = `--Boundary505_1908357336_1639130420796\r\n
    Content-Type: text/plain;charset=utf-8\r\n
    Content-Disposition: form-data; name="subject"\r\n\r\n
    ---\r\n\r\n
    --Boundary_505_1908357336_1639130420796\r\n
    Content-Type: text/plain;charset=utf-8\r\n
    Content-Disposition: form-data; name="body"\r\n`;
export const RCV_INVITATION_END = `--Boundary_505_1908357336_1639130420796--`;
